export const TOTAL_TIME_COUNT = 420000;
export const TWO_MINUTES = 120000;
export const ONE_SECOND = 1000;
export const ONE_MINUTES = 60000;
export const FIVE_MINUTES = 300000;
export const SEVEN_MINUTES = 420000;
export const TEN_MINUTES = 600000;
export const FORTYFIVE_MINUTES = 2700000;
